import { render, staticRenderFns } from "./CaseView.vue?vue&type=template&id=09cca266&scoped=true"
import script from "./CaseView.vue?vue&type=script&lang=js"
export * from "./CaseView.vue?vue&type=script&lang=js"
import style0 from "./CaseView.vue?vue&type=style&index=0&id=09cca266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cca266",
  null
  
)

export default component.exports